import { Tooltip } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { FF_AI_WEAVER } from '@/consts/featureFlags';
import { AppToggleButton } from '@/UI/AppToggleButtons/AppToggleButton';
import { useAIWeaverStore } from './aiWeaver.store';

// Flag-check shell. Returns null before any zustand subscription so flag-off
// users pay zero runtime cost.
export function AIWeaverMenuButton() {
  const { value: isEnabled } = useFeatureFlag(FF_AI_WEAVER);
  if (!isEnabled) return null;
  return <AIWeaverMenuButtonInner />;
}

function AIWeaverMenuButtonInner() {
  const isOpen = useAIWeaverStore((s) => s.isOpen);
  const toggle = useAIWeaverStore((s) => s.toggle);

  return (
    <Tooltip title="AI Weaver" placement="right" enterDelay={800} enterNextDelay={100}>
      <AppToggleButton
        mode="light"
        selected={isOpen}
        value={isOpen}
        onClick={toggle}
        isIcon
        sx={{ border: 'none' }}
        btnW={36}
        btnH={36}
      >
        <AutoAwesomeIcon />
      </AppToggleButton>
    </Tooltip>
  );
}
